
import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      {/* begin::Container */}
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        {/* begin::Copyright */}
        <div className='text-gray-900 order-2 order-md-1'>
          <span className='text-muted fw-bold me-2'>{new Date().getFullYear()} &copy;</span>
          <a href='#' className='text-gray-800 text-hover-primary'>
            {import.meta.env.VITE_APP_NAME}
          </a>
        </div>
        {/* end::Copyright */}
        <div>
          <span className='text-gray-900 order-2 order-md-1'>v{__APP_BUILD_VERSION__} {BUILD_TIMESTAMP ? BUILD_TIMESTAMP : ''}</span>
        </div>

      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
